import React from "react";
import SpecialText from "../../components/common/Typography/SpecialText";

const ProfileStats = ({ userData, onKeywordsClick, className = "" }) => {
  // Fallback stats data
  const fallbackStats = {
    followersCount: 8245,
    viewsCount: 13252,
    sharesCount: 252,
    savedCount: 95,
    keywordsCount: 186
  };

  // Get stats from userData or use fallback
  const stats = {
    followersCount: userData?.followersCount || fallbackStats.followersCount,
    viewsCount: userData?.viewsCount || fallbackStats.viewsCount,
    sharesCount: userData?.sharesCount || fallbackStats.sharesCount,
    savedCount: userData?.savedCount || fallbackStats.savedCount,
    keywordsCount: userData?.keywords ? userData.keywords.length : fallbackStats.keywordsCount
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <SpecialText variant={"Counter"}>
        {stats.followersCount.toLocaleString()} Followers
      </SpecialText>
      <div className="mx-2">
        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
      </div>
      <SpecialText variant={"Counter"}>
        {stats.viewsCount.toLocaleString()} Views
      </SpecialText>
      <div className="mx-2">
        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
      </div>
      <SpecialText variant={"Counter"}>
        {stats.sharesCount} Share
      </SpecialText>
      <div className="mx-2">
        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
      </div>
      <SpecialText variant={"Counter"}>
        {stats.savedCount} Saved
      </SpecialText>
      <div className="mx-2">
        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
      </div>
      {onKeywordsClick && (
        <span onClick={onKeywordsClick}>
          <SpecialText variant={"Counter"} className="text-offblack hover:text-primaryblue cursor-pointer">
            {stats.keywordsCount} Keywords
          </SpecialText>
        </span>
      )}
    </div>
  );
};

export default ProfileStats;
